



















































import { Component, Mixins } from 'vue-property-decorator';
import OperateFavorData from 'src/mixin/operateFavoriteData';
import { CommonRes } from 'src/types/views/common';
import { LocalRequireItem, RequireItem } from 'src/types/views/require';

@Component
export default class ProductFavor extends Mixins(OperateFavorData) {
  data: LocalRequireItem[] = [];

  url = 'requireFavorite/showList';

  pageSize = 10;

  beforeInit() {
    this.params = {
      pageNum: this.pageNum,
      pageSize: this.pageSize,
      word: this.keyword,
    };
    return true;
  }

  afterInit(res: CommonRes<RequireItem>) {
    this.data = res.data.rows.map(item => ({
      id: item.id,
      name: item.name,
      remainDays: item.deadTime,
      endTime: item.endTime,
      createTime: item.createTime.substr(0, 10),
      price: item.price,
      address: item.requiredareaname,
      industry: item.requiredindustryname,
      description: item.description.replace(/<[^>]+>|&nbsp;|\s+/g, ''),
    }));
    this.total = res.data.count || 0;
    return true;
  }

  toDetail(name: string, id: string) {
    this.$router.push({
      name,
      query: { id },
    });
  }
}
